import { createAction } from 'redux-actions';

// SITES

export const addSite = createAction('ADD_SITE', site => ({ site }));
export const addSiteSuccess = createAction('ADD_SITE_SUCCESS');
export const addSiteFail = createAction('ADD_SITE_FAIL');

export const updateSite = createAction('UPDATE_SITE', site => ({ site }));
export const updateSiteSuccess = createAction('UPDATE_SITE_SUCCESS');
export const updateSiteFail = createAction('UPDATE_SITE_FAIL');

export const getSites = createAction('GET_ADMIN_SITES');
export const getSitesSuccess = createAction('GET_ADMIN_SITES_SUCCESS', sites => ({ sites }));
export const getSitesFail = createAction('GET_ADMIN_SITES_FAIL');

export const setSite = createAction('SET_SITE', siteId => ({ siteId }));
export const setSiteSuccess = createAction('SET_SITE_SUCCESS', siteId => ({ siteId }));

// USERS

export const addUser = createAction('ADD_USER', user => ({ user }));
export const addUserSuccess = createAction('ADD_USER_SUCCESS');
export const addUserFail = createAction('ADD_USER_FAIL');

export const updateUser = createAction('UPDATE_USER', user => ({ user }));
export const updateUserSuccess = createAction('UPDATE_USER_SUCCESS');
export const updateUserFail = createAction('UPDATE_USER_FAIL');

export const getUsers = createAction('GET_USERS');
export const getUsersSuccess = createAction('GET_USERS_SUCCESS', users => ({ users }));
export const getUsersFail = createAction('GET_USERS_FAIL');

export const setUser = createAction('SET_USER', userId => ({ userId }));
export const setUserSuccess = createAction('SET_USER_SUCCESS', userId => ({ userId }));

// USER GROUPS / ORGANIZATIONS

export const addUserGroup = createAction('ADD_USER_GROUP', group => ({ group }));
export const addUserGroupSuccess = createAction('ADD_USER_GROUP_SUCCESS');
export const addUserGroupFail = createAction('ADD_USER_GROUP_FAIL');

export const updateUserGroup = createAction('UPDATE_USER_GROUP', group => ({ group }));
export const updateUserGroupSuccess = createAction('UPDATE_USER_GROUP_SUCCESS');
export const updateUserGroupFail = createAction('UPDATE_USER_GROUP_FAIL');

export const setGroup = createAction('SET_GROUP', groupId => ({ groupId }));
export const setGroupSuccess = createAction('SET_GROUP_SUCCESS', groupId => ({ groupId }));

export const getGroups = createAction('GET_GROUPS');
export const getGroupsSuccess = createAction('GET_GROUPS_SUCCESS', groups => ({ groups }));
export const getGroupsFail = createAction('GET_GROUPS_FAIL');

// USER ROLE

export const addUserRole = createAction('ADD_USER_ROLE', (user, role) => ({ user, role }));
export const addUserRoleSuccess = createAction('ADD_USER_ROLE_SUCCESS');
export const addUserRoleFail = createAction('ADD_USER_ROLE_FAIL');

export const removeUserRole = createAction('REMOVE_USER_ROLE', (user, role) => ({ user, role }));
export const removeUserRoleSuccess = createAction('REMOVE_USER_ROLE_SUCCESS');
export const removeUserRoleFail = createAction('REMOVE_USER_ROLE_FAIL');

export const getRoles = createAction('GET_ROLES');
export const getRolesSuccess = createAction('GET_ROLES_SUCCESS', roles => ({ roles }));
export const getRolesFail = createAction('GET_ROLES_FAIL');

// GENERIC

export const loadAdminData = createAction('LOAD_ADMIN_DATA');

// EMAIL TEMPLATES

export const addEmailTemplate = createAction('ADD_EMAIL_TEMPLATE', template => ({ template }));
export const addEmailTemplateSuccess = createAction('ADD_EMAIL_TEMPLATE_SUCCESS');
export const addEmailTemplateFail = createAction('ADD_EMAIL_TEMPLATE_FAIL');

export const updateEmailTemplate = createAction('UPDATE_EMAIL_TEMPLATE', template => ({ template }));
export const updateEmailTemplateSuccess = createAction('UPDATE_EMAIL_TEMPLATE_SUCCESS');
export const updateEmailTemplateFail = createAction('UPDATE_EMAIL_TEMPLATE_FAIL');

export const getAllTemplates = createAction('GET_ALL_TEMPLATES');
export const getAllTemplatesSuccess = createAction('GET_ALL_TEMPLATES_SUCCESS', templates => ({ templates }));
export const getAllTemplatesFail = createAction('GET_ALL_TEMPLATES_FAIL');

export const getTemplateById = createAction('GET_TEMPLATE_BY_ID', id => ({ id }));
export const getTemplateByIdSuccess = createAction('GET_TEMPLATE_BY_ID_SUCCESS', template => ({ template }));
export const getTemplateByIdFail = createAction('GET_TEMPLATE_BY_ID_FAIL');
